import React from 'react'
import { ParallaxBanner } from 'react-scroll-parallax';

const ImageContainer = () => {
  return (
    <div className='w-full h-full all-product-image-container'>
      <ParallaxBanner

        layers={[
          { image:"https://images.pexels.com/photos/17825245/pexels-photo-17825245/free-photo-of-brunette-in-gold-and-pearl-necklaces.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load", speed: -20 },
          
        ]}
        className="aspect-[2/1] all-product-image-container"

      >
        
      </ParallaxBanner>

    </div>
  )
}

export default ImageContainer
